import { get } from "svelte/store";
import client from "./client";
import {
	cachedTaskLookups,
	cachedJobLookups,
	cachedServiceCategories,
	cachedCancelReasons,
} from "../store/store";
import { extractErrorMessage } from "../utils/misc";

let cacheGeneration = 0;
export function invalidateLookupCaches() {
	cacheGeneration++;
}

// fetch and cache /v1/Tasks/lookups
export async function fetchTaskLookups() {
	const generation = cacheGeneration;
	try {
		const res = await client("/v1/Tasks/lookups", {
			method: "GET",
			version: "Tasking",
		});
		if (generation !== cacheGeneration) return;
		cachedTaskLookups.set(res.data);
		return;
	} catch (error) {
		console.log(error);
		extractErrorMessage(error);
		throw error;
	}
}

// fetch and cache /v1/Jobs/lookups
export async function fetchJobLookups() {
	const generation = cacheGeneration;
	try {
		const res = await client("/v1/Jobs/lookups", {
			method: "GET",
			version: "Tasking",
		});
		if (generation !== cacheGeneration) return;
		cachedJobLookups.set(res.data);
		return;
	} catch (error) {
		console.log(error);
		extractErrorMessage(error);
		throw error;
	}
}

let pendingServiceCategories = null;

// fetch once and cache GET api/fmstasking/v1/mr/maintenance/service-categories
export function fetchServiceCategories() {
	if (get(cachedServiceCategories)) return Promise.resolve();
	pendingServiceCategories ??= requestServiceCategories().finally(() => {
		pendingServiceCategories = null;
	});
	return pendingServiceCategories;
}

async function requestServiceCategories() {
	try {
		const res = await client("/v1/mr/maintenance/service-categories", {
			method: "GET",
			version: "Tasking",
		});
		const items = res.data?.items ?? res.data ?? [];
		cachedServiceCategories.set(
			[...items].sort((a, b) => a.sortOrder - b.sortOrder)
		);
	} catch (error) {
		console.log(error);
		extractErrorMessage(error);
		throw error;
	}
}

let pendingCancelReasons = null;

// fetch once and cache GET api/fmstasking/v1/mr/maintenance/cancel-reasons
export function fetchCancelReasons() {
	if (get(cachedCancelReasons)) return Promise.resolve();
	pendingCancelReasons ??= requestCancelReasons().finally(() => {
		pendingCancelReasons = null;
	});
	return pendingCancelReasons;
}

async function requestCancelReasons() {
	try {
		const res = await client("/v1/mr/maintenance/cancel-reasons", {
			method: "GET",
			version: "Tasking",
		});
		cachedCancelReasons.set(res.data?.items ?? []);
	} catch (error) {
		console.log(error);
		throw error;
	}
}
